export type SortElement = {
  id: string;
  label: string | React.ReactElement;
  active: boolean;
  defaultActive: boolean;
};

export const isActiveOrInactiveString = (
  str: unknown | undefined
): str is 'active' | 'inactive' =>
  Boolean(str) && (str === 'active' || str === 'inactive');
